import React from 'react';

import PageLayout from '../../../components/PageLayout';

import WebDesign from './WebDesign';

async function action() {
  return {
    title: 'A Web Design Company in Tucson, Arizona',
    description:
      'Web design without compromise. Our designs are mobile friendly so that your customers can view your website properly on any device.',
    chunks: ['web-design'],
    component: (
      <PageLayout>
        <WebDesign />
      </PageLayout>
    ),
  };
}

export default action;
